import React from 'react'
import * as ReactIcons from '@src/lib/react-icons'
import './style.scss'
import classNames from 'classnames'

interface PaginationProps {
  totalNumber: number,
  totalPages: number,
  currentPage: number,
  prevOnClick: () => void,
  nextOnClick: () => void,
  moveToOnClick: (pageNumber: number) => void
}

const Pagination: React.FC<PaginationProps> = (props) => {
  const { totalNumber, totalPages, currentPage, prevOnClick, nextOnClick, moveToOnClick } = props
  const handleMoveTo = (pageNumber: number) => {
    if (pageNumber === currentPage) return
    moveToOnClick(pageNumber)
  }
  const showFirstNumber = totalPages === 1 ? 1 : (currentPage - 1) * 10 + 1
  const showEndNumber = totalPages === currentPage ? totalNumber : currentPage * 10

  const paginate = () => {
    const delta = 2
    const range = []
      
    const startNum = Math.max(2, (currentPage - delta))
    const endNum = Math.min((totalPages - 1), (currentPage + delta))

    for (let i = startNum; i <= endNum; i++) range.push(i)
    if ((currentPage - delta) > 2) range.unshift('...')  
    if ((currentPage + delta) < (totalPages - 1)) range.push('...')
    range.unshift(1)
    if (totalPages !== 1) range.push(totalPages)
  
    const pages = range.map((i, index) => {
      if (i === '...') return <li key={index}><span className='pagination-span'>...</span></li>
      return (
        <li key={index}>
          <button
            className={classNames('pagination-btn', {'pagination-btn-active': i === currentPage})}
            onClick={() => handleMoveTo(parseInt(i.toString()))}
          >
            {i}
          </button>
        </li>
      )
    })

    return pages
  }

  return (
    <>
      <span className='total-number-warp'>
        {`顯示 ${showFirstNumber}-${showEndNumber} 筆，共 ${totalNumber} 筆`}
      </span>
      <span className='col-span-2' />
      {
        totalPages > 1 && 
        <span className='pagination-warp'>
          <nav className='pagination'>
            <ul>
              {
                currentPage !== 1 && <li>
                  <button className='pagination-btn' onClick={prevOnClick}>
                    <ReactIcons.GrFormPrevious />
                  </button>
                </li> 
              }
              {paginate()}
              {
                currentPage !== totalPages && <li>
                  <button className='pagination-btn' onClick={nextOnClick}>
                    <ReactIcons.GrFormNext />
                  </button>
                </li>
              }
            </ul>
          </nav>
        </span>
      }
    </>
  );
};

export default Pagination
